import UAParser from "ua-parser-js";

/**
 * 모바일이면 true 를 리턴한다.
 */
export function isMobile() {
  const ua = new UAParser(navigator.userAgent);
  return ua.getDevice().type?.toLowerCase() === "mobile";
}
